<template>
    <div class="svg-frame" :style="sizing">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "SvgComponent",
        props: [
            'width',
            'height'
        ],

        data: function() {
            return {
                sizing: 'width: 200px; height: 200px'
            }
        },

        mounted() {
            let view = this;
            this.forgivable = 150; // How far before the element is fully visible should we show it?

            this.sizing = "width: " + this.width + "; height: " + this.height;

            this.checkVisible();

            $(window).on('resize', function() {
                view.checkVisible();
            });

            $('.main').on('scroll', function() {
                view.checkVisible();
            });

            $(window).on('scroll', function() {
                view.checkVisible();
            });
        },

        methods: {
            checkVisible: function() {
                let rect = this.$el.getBoundingClientRect();

                if ( rect.top >= 0 && rect.bottom <= $(window).height() + this.forgivable ) {
                    $('.monitor-visibility', this.$el).attr( 'state-visible', true );
                }
            }
        }
    }
</script>

<style scoped>

</style>